import { ReactNode } from "react";
import classNames from 'classnames';

import "./tooltip.scss";

export enum TooltipPositions {
	topCenter = "top-center",
	topRight = "top-right",
	bottomCenter = "bottom-center",
	bottomLeft = "bottom-left",
	left = "left",
	right = "right",
}
export interface ITooltipProps {
	tooltip: JSX.Element | string;
	children: ReactNode;
	disable?: boolean;
	position?: TooltipPositions | string;
	textClassName?: string;
	containerClassName?: string;
}

export const Tooltip = ({ textClassName, tooltip, children, disable, position, containerClassName }: ITooltipProps): JSX.Element => {
	if (disable) return <>{children}</>;

	return (
		<div className={classNames("smart-tooltip", containerClassName, position ? position : "top-center")}>
			{children}
			<span className="smart-tooltip-content">
				<span className={classNames(textClassName, "smart-tooltip-text")}>{tooltip}</span>
			</span>
		</div>
	);
};
